import classNames from "classnames";
import styles from "./index.module.less";

export default function HBButtonGroup(props) {
  return (
    <div className={classNames([styles.group, props.className])}>
      {props.children}
    </div>
  );
}
